/* eslint-disable */
import MessageType from '@/shared/enums/MessageType'

export default class Message {
  constructor(public type: MessageType, public payload: unknown) { }
}
